import { select } from "redux-saga/effects";
import { createSelector } from "reselect";
import { getPrescriptionType, getIsPrescriptionUploadStepValid } from "../../../../../../state/configurator/selectors.js";
import { PRESCRIPTION_FILE, NEW_PRESCRIPTION_AND_UPLOAD } from "../../../../../../../state/constants.js";
import { PrescriptionUploadStepContainer } from "../../../../../../../../steps/PrescriptionUploadStep/steps/PrescriptionUploadStep/PrescriptionUploadStepContainer.js";
import "../../../../../../../add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../../bundles/state/bundles/selectors.js";
import "../../../../../../../bundles/state/bundles/reducer.js";
import "../../../../../../state/configurator/reducer.js";
import "../../../../../../../products/state/products/selectors.js";
import "../../../../../../../products/state/products/reducer.js";
const prescriptionUploadStepBase = {
  *onNext() {
    const isValid = yield select(getIsPrescriptionUploadStepValid);
    if (!isValid) {
      return new Error(`Need valid prescription data for unknown customer`);
    }
  },
  view: PrescriptionUploadStepContainer,
  stepStatus: createSelector(
    getPrescriptionType,
    (prescriptionType) => prescriptionType === PRESCRIPTION_FILE || prescriptionType === NEW_PRESCRIPTION_AND_UPLOAD ? "sub-step" : "hidden"
  )
};
export {
  prescriptionUploadStepBase
};
//# sourceMappingURL=prescription-upload.js.map
